function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.965 3.524L10 7v8l4.965 3.475c1.63 1.14 2.444 1.711 3.122 1.681a2 2 0 001.5-.78c.413-.539.413-1.533.413-3.522V6.146c0-1.99 0-2.984-.413-3.522a2 2 0 00-1.5-.781c-.678-.03-1.493.54-3.122 1.681zM9 15H6v4.5a1.5 1.5 0 103 0V15z",
  opacity: 0.12
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.395 4.139c.827-.58 1.405-.983 1.86-1.243.463-.265.681-.309.8-.304.369.016.712.195.937.488.072.094.16.298.21.829.047.522.048 1.227.048 2.237v9.708c0 1.01 0 1.714-.049 2.236-.048.532-.137.735-.21.83a1.25 1.25 0 01-.936.487c-.119.005-.337-.038-.8-.303-.455-.26-1.033-.664-1.86-1.243l-4.645-3.252V7.39l4.645-3.251zm5.355 10.536v1.217c0 .962 0 1.736-.055 2.335-.055.598-.172 1.16-.513 1.605a2.75 2.75 0 01-2.062 1.074c-.56.024-1.088-.202-1.61-.5-.521-.299-1.156-.743-1.943-1.294l-.032-.022-4.771-3.34H9.75v3.75a2.25 2.25 0 11-4.5 0v-3.809A4.751 4.751 0 016 6.25h3.763l4.772-3.34.032-.022c.787-.552 1.421-.996 1.944-1.294.52-.298 1.05-.525 1.61-.5a2.75 2.75 0 012.06 1.073c.342.445.46 1.008.514 1.605.055.6.055 1.373.055 2.335v1.218a3.751 3.751 0 010 7.35zm0-1.553a2.251 2.251 0 000-4.244v4.244zM9.25 7.75H6a3.25 3.25 0 100 6.5h3.25v-6.5zm-2.5 8v3.75a.75.75 0 101.5 0v-3.75h-1.5z"
});

var SvgAdvocacy = function SvgAdvocacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "#D8DAE7",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default SvgAdvocacy;